import {
  CreateReservationDocument,
  CreateReservationMutation,
  CreateReservationMutationVariables,
  DurationType,
} from "../GeneratedGraphQL";
import {
  defaultAvailabilityIntervals,
  defaultAvailabilityIntervalsRequestVariables,
} from "./availabilityIntervals";

import { defaultOrganisation } from "./organisation";
import { defaultResource } from "./resource";
import { defaultResourceGroup } from "./resourceGroup";
import { GraphQLError } from "graphql";
import { MockedResponse } from "@apollo/client/testing";

const availabilityRequestData = defaultAvailabilityIntervalsRequestVariables;
const selectedAvailabilityInterval = defaultAvailabilityIntervals[0];

export const defaultReservedSpaceId = "001002003004005006007008";

const defaultReservationsRequestVariables: CreateReservationMutationVariables =
  {
    expiresAfter: defaultOrganisation.reservationExpiryMinutes + 1,
    parts: [
      {
        end: selectedAvailabilityInterval.end,
        start: selectedAvailabilityInterval.start,
        type: DurationType.Block,
      },
    ],
    requiredSpaces: availabilityRequestData.spaces,
    serviceId: availabilityRequestData.serviceId,
    source: "mock-source",
    timeZone: availabilityRequestData.timezone,
  };

const reservationsRequestVariablesForAvailabilityStep: CreateReservationMutationVariables =
  {
    bookingToolId: "1234567890abcdef12345678",
    expiresAfter: defaultOrganisation.reservationExpiryMinutes + 1,
    parts: [
      {
        end: selectedAvailabilityInterval.end,
        start: selectedAvailabilityInterval.start,
        type: DurationType.Block,
      },
    ],
    requiredSpaces: availabilityRequestData.spaces,
    serviceId: availabilityRequestData.serviceId,
    source: "mock-source",
    timeZone: availabilityRequestData.timezone,
  };

const defaultReservationResult = {
  data: {
    createReservation: {
      reservation: { start: selectedAvailabilityInterval.start },
      reservedSpace: { _id: defaultReservedSpaceId },
    },
  },
};

export const defaultCreateReservationRequest = {
  request: {
    query: CreateReservationDocument,
    variables: defaultReservationsRequestVariables,
  },
  result: defaultReservationResult,
};

export const createReservationRequestForAvailabilityStep = {
  request: {
    query: CreateReservationDocument,
    variables: reservationsRequestVariablesForAvailabilityStep,
  },
  result: defaultReservationResult,
};

const createReservationForSecondIntervalRequestVariables: CreateReservationMutationVariables =
  {
    expiresAfter: defaultOrganisation.reservationExpiryMinutes + 1,
    parts: [
      {
        end: defaultAvailabilityIntervals[1].end,
        start: defaultAvailabilityIntervals[1].start,
        type: DurationType.Block,
      },
    ],
    requiredSpaces: availabilityRequestData.spaces,
    serviceId: availabilityRequestData.serviceId,
    source: "mock-source",
    timeZone: availabilityRequestData.timezone,
  };

const createReservationForSecondIntervalResult = {
  data: {
    createReservation: {
      reservation: { start: defaultAvailabilityIntervals[1].start },
      reservedSpace: { _id: defaultReservedSpaceId },
    },
  },
};

export const createReservationForSecondIntervalRequest = {
  request: {
    query: CreateReservationDocument,
    variables: createReservationForSecondIntervalRequestVariables,
  },
  result: createReservationForSecondIntervalResult,
};

export const resourceCreateReservationRequest: MockedResponse<CreateReservationMutation> =
  {
    request: {
      query: CreateReservationDocument,
      variables: {
        ...defaultReservationsRequestVariables,
        resourceId: defaultResource._id,
      },
    },
    result: defaultReservationResult,
  };

export const resourceGroupCreateReservationRequest: MockedResponse<CreateReservationMutation> =
  {
    request: {
      query: CreateReservationDocument,
      variables: {
        ...defaultReservationsRequestVariables,
        resourceGroupId: defaultResourceGroup._id,
      },
    },
    result: defaultReservationResult,
  };

export const invalidOrAlteredResourceGroupCreateReservationRequest: MockedResponse<CreateReservationMutation> =
  {
    request: {
      query: CreateReservationDocument,
      variables: {
        ...defaultReservationsRequestVariables,
        resourceGroupId: defaultResourceGroup._id,
      },
    },
    result: {
      data: null,
      errors: [new GraphQLError("Response code 422 (Unprocessable Entity)")],
    },
  };

export const failedResourceGroupCreateReservationRequest: MockedResponse<CreateReservationMutation> =
  {
    request: {
      query: CreateReservationDocument,
      variables: {
        ...defaultReservationsRequestVariables,
        resourceGroupId: defaultResourceGroup._id,
      },
    },
    result: {
      data: null,
      errors: [
        new GraphQLError("++?????++ Out of Cheese Error. Redo From Start"),
      ],
    },
  };

export const invalidOrAlteredCreateReservationRequest = {
  request: {
    query: CreateReservationDocument,
    variables: defaultReservationsRequestVariables,
  },
  result: {
    data: null,
    errors: [new GraphQLError("Response code 422 (Unprocessable Entity)")],
  },
};

export const invalidOrAlteredCreateReservationRequestForAvailabilityStep = {
  request: {
    query: CreateReservationDocument,
    variables: {
      ...reservationsRequestVariablesForAvailabilityStep,
      intervalResourceIds: [defaultResource._id],
    },
  },
  result: {
    data: null,
    errors: [new GraphQLError("Response code 422 (Unprocessable Entity)")],
  },
};

export const failedCreateReservationRequest = {
  request: {
    query: CreateReservationDocument,
    variables: defaultReservationsRequestVariables,
  },
  result: {
    data: null,
    errors: [
      new GraphQLError("++?????++ Out of Cheese Error. Redo From Start"),
    ],
  },
};

export const failedCreateResourceReservationRequest = {
  request: {
    query: CreateReservationDocument,
    variables: {
      ...defaultReservationsRequestVariables,
      resourceId: defaultResource._id,
    },
  },
  result: {
    data: null,
    errors: [
      new GraphQLError("++?????++ Out of Cheese Error. Redo From Start"),
    ],
  },
};

export const invalidOrAlteredCreateResourceReservationRequest = {
  request: {
    query: CreateReservationDocument,
    variables: {
      ...defaultReservationsRequestVariables,
      resourceId: defaultResource._id,
    },
  },
  result: {
    data: null,
    errors: [new GraphQLError("Response code 422 (Unprocessable Entity)")],
  },
};
